import { Injectable } from '@angular/core';
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';

import { SharedConstants } from '../shared.const';

@Injectable()
export class AlertManagerService {

  private toastOptions:ToastOptions = {
      title: "",
      msg: "",
      showClose: true,
      timeout: 5000,
      theme: "material"
  };
  constructor(
    private toastyService: ToastyService,
    private toastyConfig: ToastyConfig
  ) { 
    this.toastyConfig.theme = "material";
  }

  default(options){
      this.toastyService.default(this.getToastOption(options));
  }

  info(options){
      this.toastyService.info(this.getToastOption(options));
  }

  success(options){
      this.toastyService.success(this.getToastOption(options));
  }

  wait(options){
      this.toastyService.wait(this.getToastOption(options));
  }

  error(options){
      this.toastyService.error(this.getToastOption(options));
  }

  warning(options){
      this.toastyService.warning(this.getToastOption(options));
  }

  private getToastOption(options){
    this.toastOptions.title = options.title;
    this.toastOptions.msg = options.msg;
    return this.toastOptions;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/alert-manager.service.ts